<template>
  <el-dialog
      title="提示"
      :close-on-click-modal="false"
      :top="top"
      :visible="visible"
      :width="width"
      height="600px"
      :before-close="close"
      :show-close="false"
      :modal-append-to-body="modalAppendToBody"
      :append-to-body="appendToBody"
  >
    <template v-slot:title>
      <div class="table-box">
        <header>
          <slot name="header">
            <div>
              <div class="line"/>
              {{ title }}
            </div>
          </slot>
          <i class="el-icon-close" @click="close"/>
        </header>
      </div>
    </template>
    <div class="body-box">
      <slot name="body"/>
    </div>
    <footer>
      <slot name="footer"/>
    </footer>
  </el-dialog>
</template>

<script>
export default {
  name: "index",
  props: {
    show: {default: false},
    width: {default: '30%'},
    title: '',
    top: {default: "15vh"},
    modalAppendToBody: {default: false},
    appendToBody: {default: false},
  },

  data() {
    return {}
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(newValue) {
        this.$emit('update:show', newValue)
      }
    }
  },
  methods: {
    close() {
      this.visible = false
    }
  }

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header, .el-dialog__body {
    padding: 0;
  }

  .el-dialog__body {
    padding-bottom: 15px;
  }

  header {
    background: var(--nav-bg);
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      cursor: pointer;
      font-size: 22px;
    }
  }

  .body-box {
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #3B4859;
      margin: 10px 0;
      padding-bottom: 10px;
      border-bottom: 1px solid #E7EEF6;
    }

    .title:first-child {
      margin-top: 0;
    }

    .ul {
      .li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;

        > label {
          font-weight: 400;
          color: #3B4859;
          flex-shrink: 0;
        }
      }
    }
  }

  footer {
    display: flex;
    justify-content: center;
  }
}

</style>
